import type { TranslateService } from '@ngx-translate/core';

import { DialogComponent } from 'components/molecules/dialog/dialog.component';
import type { TDialogButtonsIdentifiers } from 'components/molecules/dialog/entities/types';
import type { ModalService } from 'components/organisms/modal';
import type { IConsentState, TConsentType } from 'src/services/personal-data-protection/types';
import {
    getStringsForAdvertisingCookiesNoticePopup,
    getStringsForFunctionalCookiesNoticePopup,
} from 'src/shared/constants/strings/gdpr-strings';

import { UC_SERVICE_TO_CONSENT_CAT, UC_SERVICES } from './entities/const';
import type { UserCentricsService } from './user-centrics.service';

export function userCentricsNoticePopupFactory(
    translateService: TranslateService,
    modalService: ModalService,
    userCentricsService: UserCentricsService
) {
    return (actionType: TConsentType): Promise<IConsentState> => {
        const trustArcNoticeStrings =
            actionType === UC_SERVICE_TO_CONSENT_CAT[UC_SERVICES.Advertising]
                ? getStringsForAdvertisingCookiesNoticePopup(translateService.instant)
                : getStringsForFunctionalCookiesNoticePopup(translateService.instant);

        return translateService
            .get(Object.values(trustArcNoticeStrings))
            .toPromise()
            .then((translations) => {
                return Object.keys(trustArcNoticeStrings).reduce((acc, key) => {
                    const translationOriginalValue = trustArcNoticeStrings[key];
                    acc[key] = translations[translationOriginalValue];
                    return acc;
                }, {});
            })
            .then((translatedStrings) => {
                return modalService
                    .open(
                        DialogComponent,
                        {
                            container: 'dialog',
                            withCloseOnEscape: false,
                            withCloseOnOverlayClick: false,
                            withAnimation: false,
                            withFocusTrap: false,
                        },
                        { actionType, strings: translatedStrings, dialogTestId: 'cookie-prefs-popup' }
                    )
                    .beforeClosing$.toPromise()
                    .then((buttonIdentifier: TDialogButtonsIdentifiers) => {
                        if (buttonIdentifier === 'secondary') {
                            userCentricsService.openCookiePreferences();
                        }

                        return { [actionType]: false };
                    });
            });
    };
}
